const normalize = (value) => String(value || "").trim();
const normalizeParts = (profileData = {}) =>
  [normalize(profileData?.Nombre), normalize(profileData?.Apellido)].filter(Boolean).join(" ").trim();

const extractFromEmail = (email) => {
  const normalized = normalize(email);
  if (!normalized.includes("@")) return normalized;
  return normalized.split("@")[0];
};

export const resolveUserDisplayName = ({ user, profileData } = {}) => {
  const fromProfileParts = normalizeParts(profileData);
  if (fromProfileParts) return fromProfileParts;

  const fromProfile = normalize(profileData?.Titular);
  if (fromProfile) return fromProfile;

  const fromAuthDisplayName = normalize(user?.displayName);
  if (fromAuthDisplayName) return fromAuthDisplayName;

  const fromEmail = extractFromEmail(user?.email);
  if (fromEmail) return fromEmail;

  return "Usuario";
};
